import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { Helmet } from "react-helmet";
import logo from "../assets/images/sana.png";
import "../assets/styles/Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTooth } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
        />
      </Helmet>

      <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? "bg-purple shadow" : "bg-transparent"}`}>
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="#inicio">
            <FontAwesomeIcon icon={faTooth} size="lg" className="me-2 tex-white" />
            <span className="text-white">SANA</span>
          </a>

          <button
            className={`navbar-toggler`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => { setScrolled(true); }}

          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1 text-center">
              <li className="nav-item">
                <Link className="nav-link" to="inicio" smooth duration={500}>Inicio</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="servicios" smooth duration={500}>Servicios</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="ubicacion" smooth duration={500}>Ubicación</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="opiniones" smooth duration={500}>Opiniones</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="redes" smooth duration={500}>Redes</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="portafolio" smooth duration={500}>Galería</Link>
              </li>
              <a id="agenda" href="https://wa.me/5212721986870" class="btn btn-primary ms-3">Agendar Cita</a>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
